
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import SvgBase from '../SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
})
export default class IconWeightMeasurement extends Vue {
  @Prop({ default: 'currentColor' }) readonly color!: string
}
